export const optionsObjectToArray = (object: { [key: string]: string; }) => {
  return Object.keys(object).map((key) => ({ value: key, label: object[key as keyof typeof object] }));
};